import { render } from "./WechatLogin.vue?vue&type=template&id=3ff52c50&scoped=true&ts=true"
import script from "./WechatLogin.vue?vue&type=script&lang=ts"
export * from "./WechatLogin.vue?vue&type=script&lang=ts"

import "./WechatLogin.vue?vue&type=style&index=0&id=3ff52c50&scoped=true&lang=css"

import exportComponent from "/home/build/jenkins/workdir/workspace/fast-build/fast-build/67161/vshow-main/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ff52c50"]])

export default __exports__